<template>
    <project-step-container
            prev-to="be_rapid_experiments_with_customers_18"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row>
            <b-col cols="12" class="main-text pb-3" tabindex="0">
                {{getMessage(19, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide"  :text="getMessage(19, 'rapidexperiment-guide')" ></LinkStyleGuide>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/BeEntrepreneurship/Utils";

    export default {
        name: "RapidExperimentsWithCustomers19",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_RAPID_EXPERIMENTS_TYPES_EXPERIMENTS,
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.TYPES_EXPERIMENTS)
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection() {
                const index = this.$route.params.index
                this.$router.push({name: 'be_rapid_experiments_with_customers_20', params: {index}})
            }
        }
    }
</script>

